/**
 * Login API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const loginApi = {
    // 로그인(login)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-account-sign-in-password-and-social
    login(params) {
        return httpService.post('/auth/login', params)
    },

    idpLogin(params) {
        return httpService.post('/idp/auth/login', params)
    },

    // 로그 아웃(logout)
    logout() {
        return httpService.put('/auth/logout')
    },

    // 토큰 유효성 체크(Token Validity Check)
    validToken() {
        return httpService.get('/auth/valid')
    },

    // 헤더 토큰 설정(set Header Token)
    setAuthInHeader(token) {
        localStorage.setItem('token', token)
        httpService.setAuthInHeader(token)
    },

    fetchMember(params) {
        return httpService.get(`/membership/member`, params);
    },

    // 토큰으로 로그인 유효성 체크
    authToken() {
        return httpService.get(`/idp/login/info`);
    },

    // 휴면 해제
    restoreDormancy(params) {
        return httpService.put(`/guest/membership/member/disposal/${params.id}/restore`, params);
    },

    // 매장양도양수 이력 확인
    checkStoreTransfer() {
        return httpService.put("/corporation/store/transfer/check");
    },
    // 토큰으로 로그인 유효성 체크
    authToken() {
        return httpService.get(`/idp/login/info`);
    },

    // 첫 로그인 이후 회원 인증 API (로그인 대체 API)
    authCheck() {
        return httpService.get('/membership/member/auth');
    },
}

export default loginApi
